import React from 'react';

import routes from 'js/core_pre_webpack/routes';

import { IconAnchor, IconContainer, IconLabel } from './styles';
import HomeIcon from './home.svg';

const HomeButton = () => (
  <IconAnchor
    key="home"
    href={routes.home_url({ from_navbar: true, trigger: 'nav' })}
  >
    <IconContainer>
      <HomeIcon size={25} />
    </IconContainer>
    <IconLabel>Home</IconLabel>
  </IconAnchor>
);

export default HomeButton;
